import classNames from "classnames";
import React from "react";

import { IndividualSvg } from "../../../../../components/svg/IndividualSvg";
import { OrganizationSvg } from "../../../../../components/svg/OrganizationSvg";
import { AddContactType } from "../model/addContact.types";

type ContactTypeCardProps = {
  type: AddContactType;
  title: string;
  description: string;
  onSelect: (type: AddContactType) => void;
};

export const ContactTypeCard: React.FC<ContactTypeCardProps> = ({
  type,
  title,
  description,
  onSelect,
}) => {
  return (
    <button
      type={"button"}
      onClick={() => onSelect(type)}
      className={classNames(
        "relative flex h-[206px] flex-col items-center justify-center rounded border bg-white px-4 text-center transition-colors",
        "border-[#D1D5DB] hover:border-[#6E3BE9] hover:bg-[#F6F2FF]",
      )}>
      {type === "individual" ? (
        <IndividualSvg width={64} height={64} />
      ) : (
        <OrganizationSvg width={64} height={64} />
      )}
      <div
        className={
          "mb-2 mt-4 border-b border-[#D1D5DB] pb-2 text-[18px] font-semibold text-[#111827]"
        }>
        {title}
      </div>
      <div className={"text-sm text-gray-500"}>{description}</div>
    </button>
  );
};
